import styled from "@emotion/styled";
import { theme } from "@product/scmp-sdk";

import LogoStyle from "scmp-app/components/section/section-style/icon-logo-style.svg";

import LogoScmp from "./logo-scmp.svg";
import LogoStyleCaptionMobile from "./logo-style-caption-mobile.svg";
import LogoStyleCaption from "./logo-style-caption.svg";

export const StyledLogoStyle = styled(LogoStyle)`
  inline-size: 116px;
  block-size: 74px;
  margin-block-end: 24px;

  path {
    fill: #ffffff;
  }
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 16px;
  }
`;

export const StyledLogoStyleCaption = styled(LogoStyleCaption)`
  inline-size: 161px;
  block-size: 42px;

  ${theme.breakpoints.down("tablet")} {
    display: none;
  }
`;

export const StyledLogoStyleCaptionMobile = styled(LogoStyleCaptionMobile)`
  inline-size: 161px;
  block-size: 42px;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const StyledLogoScmp = styled(LogoScmp)`
  inline-size: 162px;
  block-size: 16.6px;
`;
